//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosPost } from '../../axios/axios.js'

export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    brigade: {
      type: Object,
      default: function () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loading: false,
      success: false,
      captcha: null,
      email: null,
      captchaSrc: null
    }
  },
  watch: {
    opened: function (val) {
      this.captcha = null
      this.email = null
      this.success = false
      this.loading = false
      if (val) {
        this.captchaSrc = '/service/delta/resetPassword/recaptchaimage?' + new Date().getTime()
      }
    }
  },
  methods: {
    updateCaptcha: function () {
      this.captchaSrc = '/service/delta/resetPassword/recaptchaimage?' + new Date().getTime()
    },
    onInputMail: function (event) {
      this.email = this.email.replaceAll(/\s+/g, '')
    },
    onApply: function () {
      this.loading = true
      this.success = false

      const bodyFormData = new FormData()
      bodyFormData.set('email', this.email)
      bodyFormData.set('recaptchaResponse', this.captcha)

      return axiosPost({
        url: '/service/delta/resetPassword/sendEmail',
        data: bodyFormData,
        onSuccess: () => {
          this.success = true
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onClose: function () {
      this.$emit('close')
    }
  }
}

